// extracted by mini-css-extract-plugin
export default {"approvalTimeoutCell":"ApprovalTimeout_approvalTimeoutCell","timeoutMessageText":"ApprovalTimeout_timeoutMessageText","tooltip":"ApprovalTimeout_tooltip"};